import _mapValues from 'lodash/mapValues'
import _uniqueId from 'lodash/uniqueId'
import keyMirror from 'keymirror'

export const constants = _mapValues(keyMirror({
  SET_PROFILE_UI: null,
  SET_PROFILE_UI_DATA: null,

  FETCH_CURRENT_PROFILE_STARTED: null,
  FETCH_CURRENT_PROFILE_FAILED: null,

  UPDATE_PROFILE_STARTED: null,
  UPDATE_PROFILE_FAILED: null,
  UPDATE_PROFILE_SUCCESS: null,

  CHECK_USER_HANDLE_EXISTENCE_STARTED: null,
  CHECK_USER_HANDLE_EXISTENCE_FAILED: null,
  RECEIVE_USER_HANDLE_EXISTENCE: null,
  RECEIVE_USER_GLOBAL_HANDLE_EXISTENCE: null,

  FETCH_USER_PROFILE: null,
  FETCH_USER_PROFILE_PENDING: null,
  FETCH_USER_PROFILE_SUCCESS: null,
  FETCH_USER_PROFILE_FAILED: null,

  SET_VISIBILITY_STARTED: null,
  SET_VISIBILITY_FAILED: null,

  RECEIVE_PROFILE: null,

  CLEAR_COVER_PHOTO: null,
  UPLOAD_COVER_PHOTO_STARTED: null,
  UPLOAD_COVER_PHOTO_SUCCESS: null,
  UPLOAD_COVER_PHOTO_FAILED: null,
}), _uniqueId)

export const Visibility = keyMirror({
  PUBLIC: null,
  PRIVATE: null,
})

export const Layout = keyMirror({
  WIDE: null,
  CARD: null,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/profile/constants.js